/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import compose from 'transmute/compose';
import { NavMarker } from 'react-rhumb';
import { fromJS } from 'immutable';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import mapProps from 'dashboard-components/decorator/mapProps';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import UISection from 'UIComponents/section/UISection';
import { parseAsQueryMap } from '../../lib/historyUtils';
import H2 from 'UIComponents/elements/headings/H2';
import { Routes } from '../../constants/route/DashboardRoute';
import * as DashboardRouter from '../../lib/dashboard-router';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import EmailDAO from '../../data/EmailDAO';
import { notifyUnsubscribeSuccess, notifyUnsubscribeFailure, notifyWrongUnsubscribeLink } from '../alerts/UnsubscribeAlerts';
import { Flex } from 'foundations-components/components/Flex';
import { track as dashboardTracker, EVENTS } from 'dashboard-ui-components/tracking/DashboardUITracker';
import { selectUserEmail, selectUserId } from 'dashboard-lib/public/userInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EmailUnsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSubject: null
    };
  }
  componentDidMount() {
    const {
      emailId,
      history,
      recipientId
    } = this.props;
    if (!emailId || !recipientId) {
      DashboardRouter.route(Routes.DASHBOARD, null, null, history);
    } else {
      EmailDAO.fetchDashboardScheduleById({
        reportEmailId: emailId
      }).then(email => this.setState({
        emailSubject: fromJS(email).get('subject')
      }));
    }
  }
  render() {
    const {
      emailSubject
    } = this.state;
    const {
      emailId,
      history,
      recipientId,
      userId,
      userEmail: recipientEmail
    } = this.props;
    if (!emailSubject) {
      return /*#__PURE__*/_jsx(UIFlex, {
        direction: "column",
        justify: "around",
        align: "center",
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          minHeight: 300
        })
      });
    }
    if (recipientId !== userId) {
      DashboardRouter.route(Routes.DASHBOARD, null, null, history);
      notifyWrongUnsubscribeLink(recipientEmail, emailSubject);
    }
    const onSubmit = () => {
      dashboardTracker(EVENTS.unsubscribeRecurringEmail);
      DashboardRouter.route(Routes.DASHBOARD, null, null, history);
      EmailDAO.unsubscribeEmailRecipient({
        reportEmailId: emailId,
        recipientUserId: recipientId
      }).then(() => {
        notifyUnsubscribeSuccess(recipientEmail, emailSubject);
      }).catch(() => {
        notifyUnsubscribeFailure(recipientEmail, emailSubject);
      });
    };
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "EMAIL_UNSUBSCRIBE_PAGE_LOADED",
      children: /*#__PURE__*/_jsx(UISection, {
        use: "island",
        children: /*#__PURE__*/_jsx(UIFlex, {
          direction: "column",
          justify: "around",
          align: "center",
          children: /*#__PURE__*/_jsx(Box, {
            maxInlineSize: "500px",
            alignSelf: "center",
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              textAlign: "center",
              children: [/*#__PURE__*/_jsx(H2, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: 'emailUnsubscribe.confirmPage.title',
                  options: {
                    emailSubject
                  }
                })
              }), /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: 'emailUnsubscribe.confirmPage.message',
                  options: {
                    email: recipientEmail,
                    emailSubject
                  }
                })
              }), /*#__PURE__*/_jsxs(UIButtonWrapper, {
                justify: "center",
                children: [/*#__PURE__*/_jsx(UIButton, {
                  use: "primary",
                  onClick: onSubmit,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: 'emailUnsubscribe.confirmPage.confirm'
                  })
                }), /*#__PURE__*/_jsx(UIButton, {
                  use: "tertiary-light",
                  onClick: () => {
                    DashboardRouter.route(Routes.DASHBOARD, null, null, history);
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: 'emailUnsubscribe.confirmPage.reject'
                  })
                })]
              })]
            })
          })
        })
      })
    });
  }
}
EmailUnsubscribe.propTypes = {
  emailId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  recipientId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired
};
export default compose(mapProps(history => {
  const queryMap = parseAsQueryMap(history);
  return {
    emailId: parseInt(queryMap.email, 10),
    recipientId: parseInt(queryMap.recipient, 10)
  };
}), withRouter, connect(state => {
  return {
    userId: selectUserId(state),
    userEmail: selectUserEmail(state)
  };
}))(EmailUnsubscribe);